import React from 'react';
import { Row } from 'reactstrap';
import RoomSidebar from './RoomSidebar';
import RoomsItem from './RoomsItem';

const RoomsGrid = ({ rooms, total, loading, handlePagination }) => {
  return (
    <div
      className="main-wrapper room-page"
      style={{
        backgroundColor: '#F0F2F5',
      }}
    >
      <section className="room-grid-area">
        <div className="custom-container">
          <Row>
            <RoomSidebar />
            <div className="room-items mt-3">
              <Row>
                <RoomsItem
                  rooms={rooms}
                  total={total}
                  loading={loading}
                  handlePagination={handlePagination}
                />
              </Row>
            </div>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default RoomsGrid;
